module.exports = __webpack_public_path__ + "static/media/sanmi_koyejo.0f222171.png";